import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getImageShimmerStyles } from '../../styles/shared-components/image-shimmer-styles';

const ImageShimmerImpl = ({ className, classes }) => (
  <div className={classNames(classes.imageShimmerRoot, className)} />
);

ImageShimmerImpl.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}).isRequired,
};

ImageShimmerImpl.defaultProps = {
  className: undefined,
};

export const ImageShimmer = withDefaultStyles(ImageShimmerImpl, getImageShimmerStyles);
